import { InjectionToken } from '@angular/core';

export interface WidgetsRecaptchaConfig {
  v3SiteKey: string;
  v2SiteKey: string;
}

export const WIDGETS_RECAPTCHA_CONFIG = new InjectionToken<WidgetsRecaptchaConfig>(
  'WIDGETS_RECAPTCHA_CONFIG',
);
